import Swiper from "swiper";

export const SwiperTestimonials = () => {
	const swiper = new Swiper(".swiper-testimonials", {
		loop: false,
		slidesPerView: 3,
		spaceBetween: 8,
		breakpoints: {
			0: {
				slidesPerView: 1,
			},
			768: {
				slidesPerView: 2,
			},
			1024: {
				spaceBetween: 24,
				slidesPerView: 3,
			},
		},
	});


	const prevBtn = document.getElementById("swiper-testimonials-prev");
	const nextBtn = document.getElementById("swiper-testimonials-next");

	// Add disabled ao btn quando preciso
	const updateNavButtons = () => {
		if (swiper.isBeginning) {
			prevBtn.disabled = true;
		} else {
			prevBtn.disabled = false;
		}

		if (swiper.isEnd) {
			nextBtn.disabled = true;
		} else {
			nextBtn.disabled = false;
		}
	};

	prevBtn.addEventListener("click", () => {
		swiper.slidePrev();
		updateNavButtons();
	});

	nextBtn.addEventListener("click", () => {
		swiper.slideNext();
		updateNavButtons();
	});

	updateNavButtons();
};
